var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"text-h3 text-sm-h2"},[_c('span',{staticClass:"accent--text"},[_vm._v("@")]),_vm._v("metafates ")])])}]

export { render, staticRenderFns }